export default __webpack_public_path__ + "static/media/VEB_cancer.030e2248.png";